/* Bedtextielonline (Claude), productpagina:
   - "Je bespaart €X" naast de prijs, ook na wisselen van maat
   - Uitklapblokken onder de foto's starten dicht
   - Vaste koopbalk onderaan tonen zolang de koopknop niet in beeld is, ook meteen bij openen (zoals HappyBed).
     Het thema vervangt de balk en de koopknop bij het wisselen van maat, daarom telkens opnieuw opzoeken.
   - Gekozen maat ook zichtbaar in de koopbalk; hoekhoogte-keuze per kaartje verborgen als de matrashoogte bovenaan gekozen wordt.
   De bijhorende stijl staat in btol-globaal.css (laadt meteen, geen verspringen). */
(function () {
  function geld(t) {
    var s = (t || '').replace(/[^\d,.]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    return parseFloat(s);
  }
  function euro(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return '€' + s;
  }
  function werk() {
    var lijsten = document.querySelectorAll('.product-info price-list');
    for (var i = 0; i < lijsten.length; i++) {
      var pl = lijsten[i];
      var sp = pl.querySelector('sale-price'), cp = pl.querySelector('compare-at-price');
      var span = pl.querySelector('.btol-bespaar');
      var tekst = '';
      if (sp && cp) {
        var a = geld(sp.textContent), b = geld(cp.textContent);
        if (a > 0 && b > a) tekst = 'Je bespaart ' + euro(b - a);
      }
      if (!tekst) { if (span) span.remove(); continue; }
      if (!span) { span = document.createElement('span'); span.className = 'btol-bespaar'; pl.appendChild(span); }
      if (span.textContent !== tekst) span.textContent = tekst;
    }
  }
  function koopbalk() {
    var balk = document.querySelector('product-sticky-bar');
    var koop = Array.prototype.find.call(document.querySelectorAll('.product-info buy-buttons'), function (el) {
      return !el.closest('product-sticky-bar') && !el.closest('.complementary-products');
    });
    if (!balk || !koop) return;
    var r = koop.getBoundingClientRect();
    var inBeeld = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
    maatInBalk();
    if (balk.classList.contains('btol-zichtbaar') === inBeeld) balk.classList.toggle('btol-zichtbaar', !inBeeld);
  }
  /* Gekozen maat ook in de koopbalk (zonder kleur, die staat al in de titel) */
  var btolProd = null, btolProdBezig = false;
  function maatInBalk() {
    var balk = document.querySelector('product-sticky-bar');
    if (!balk) return;
    if (!btolProd) {
      if (btolProdBezig) return;
      btolProdBezig = true;
      var h = location.pathname.split('/products/')[1];
      if (!h) return;
      fetch('/products/' + h.split('/')[0].split('?')[0] + '.js').then(function (r) { return r.json(); })
        .then(function (p) { btolProd = p; maatInBalk(); }).catch(function () {});
      return;
    }
    if (!btolProd.variants || btolProd.variants.length < 2) return;
    var form = balk.getAttribute('form');
    var idEl = form && document.querySelector('form#' + CSS.escape(form) + ' [name="id"]');
    var vid = idEl ? idEl.value : new URLSearchParams(location.search).get('variant');
    var v = btolProd.variants.find(function (x) { return String(x.id) === String(vid); }) || btolProd.variants[0];
    var delen = [];
    (btolProd.options || []).forEach(function (o, i) {
      var naam = (o.name || o).toString().toLowerCase();
      if (naam.indexOf('kleur') > -1) return;
      if (v.options[i]) delen.push(v.options[i]);
    });
    var tekst = delen.join(' · ');
    if (!tekst) return;
    var titel = balk.querySelector('.product-sticky-bar__info .h6');
    if (titel) {
      var s = balk.querySelector('.btol-sticky-maat:not(.btol-sticky-maat--gsm)');
      if (!s) { s = document.createElement('span'); s.className = 'btol-sticky-maat'; titel.insertAdjacentElement('afterend', s); }
      if (s.textContent !== tekst) s.textContent = tekst;
    }
    var g = balk.querySelector('.btol-sticky-maat--gsm');
    if (!g) { g = document.createElement('span'); g.className = 'btol-sticky-maat btol-sticky-maat--gsm'; balk.insertBefore(g, balk.firstChild); }
    if (g.textContent !== 'Maat: ' + tekst) g.textContent = 'Maat: ' + tekst;
  }
  function start() {
    werk();
    var dicht = document.querySelectorAll('.product-content-below-gallery details[open]');
    for (var k = 0; k < dicht.length; k++) dicht[k].open = false;

    window.addEventListener('scroll', koopbalk, { passive: true });
    window.addEventListener('resize', koopbalk);
    setInterval(koopbalk, 800);
    koopbalk();

    var info = document.querySelector('.product-info');
    if (info && window.MutationObserver) {
      var bezig = false;
      new MutationObserver(function () {
        if (bezig) return; bezig = true;
        requestAnimationFrame(function () { werk(); bezig = false; });
      }).observe(info, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
